import { connect } from 'react-redux'
import { get, keys, map, includes, filter, find } from 'lodash'
import { withRouter } from 'react-router-dom'

import { loadPreOrders } from '../../store/Order/actions'
import { loadRevenueCenters } from '../../store/RevenueCenter/actions'
import { loadCustomers } from '../../store/Customer/actions'
import { createCustomerOrderingPreferences, removeCustomerOrderingPreference } from '../../store/CustomerOrderingPreference/actions'
import { getNewlyCreatedCustomerId, getNewlyRemovedCustomerId, getIsOrderingPreferencesLoading } from '../../store/CustomerOrderingPreference/selector'
import { loadAllCustomerOrderingPreferencesByEventId } from '../../store/CustomerOrderingPreference/actions'
import { loadSuitesStaff } from '../../store/Staff/actions'
import { loadAttendantSettings, createAttendantSetting, updateAttendantSetting } from '../../store/AppDeviceConfiguration/actions'
import { getAttendantSettingsByEmployeeUuidAndEventId, getAttendantSettingsByEmployeeUuid } from '../../store/AppDeviceConfiguration/selector'
import { getAttendants } from '../../store/Staff/selector'
import { getSelectedSuites, makeGetDisplaySuite, makeGetDisplaySuites, getPendingCustomerOrderingPreferenceIds } from '../../store/Suite/selector'
import { getCurrentVenueUuid } from '../../store/Venues/selector'
import { getCustomers, makeGetCustomerDefaultPreferences, getCustomerDefaultPreferenceUuids } from '../../store/Customer/selector'
import { getEmployeeRoles } from '../../store/EmployeeRole/selector'

import SuiteEdit from '../../components/Suite/Edit'

const mapStateToProps = (state, ownProps) => {
  const eventId = get(ownProps, 'match.params.eventId')
  const editPage = get(ownProps, 'match.params.customerOrAttendant')
  const attendants = getAttendants(state)
  const gloabalAttendantSettings = getAttendantSettingsByEmployeeUuid(state)
  const attendantSettings = getAttendantSettingsByEmployeeUuidAndEventId(state, eventId)
  const customers = getCustomers(state)
  const suiteUuids = keys(getSelectedSuites(state))
  const getDisplaySuite = makeGetDisplaySuite()
  const getDisplaySuites = makeGetDisplaySuites()
  const suites = map(suiteUuids, (suiteId) => getDisplaySuite(state, eventId, suiteId))
  const anonymousCustomerExists = !!find(filter(getDisplaySuites(state, eventId), (suite) => includes(suiteUuids, suite.rvcUuid)), (suite) => find(suite.customers, (customer) => !customer.customerId))
  const currentVenueUuid = getCurrentVenueUuid(state)
  const employeeRoles = getEmployeeRoles(state)
  const getCustomerDefaultPreferences = makeGetCustomerDefaultPreferences()
  const customerDefaultPreferences = getCustomerDefaultPreferences(state, ownProps)
  const customerDefaultPreferenceUuids = getCustomerDefaultPreferenceUuids(state)
  const pendingCustomerOrderingPreferenceIds = getPendingCustomerOrderingPreferenceIds(state)
  const newlyCreatedCustomerId = getNewlyCreatedCustomerId(state)
  const newlyRemovedCustomerId = getNewlyRemovedCustomerId(state)
  const isLoading = getIsOrderingPreferencesLoading(state)

  return {
    anonymousCustomerExists,
    attendants,
    attendantSettings,
    currentVenueUuid,
    customerDefaultPreferences,
    customerDefaultPreferenceUuids,
    customers,
    editPage,
    employeeRoles,
    eventId,
    gloabalAttendantSettings,
    isLoading,
    newlyCreatedCustomerId,
    newlyRemovedCustomerId,
    pendingCustomerOrderingPreferenceIds,
    suites,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const salesEventId = get(ownProps, 'match.params.eventId', '')

  return {
    createCustomerOrderingPreferences: (customerId, payload) => dispatch(createCustomerOrderingPreferences(customerId, payload)),
    loadAllCustomerOrderingPreferencesByEventId: () => dispatch(loadAllCustomerOrderingPreferencesByEventId(salesEventId)),
    loadAttendantSettings: (currentVenueUuid, params) => dispatch(loadAttendantSettings(currentVenueUuid, params)),
    loadCustomers: (currentVenueUuid) => dispatch(loadCustomers(currentVenueUuid)),
    loadPreOrders: (currentVenueUuid) => dispatch(loadPreOrders(currentVenueUuid, salesEventId)),
    loadRevenueCenters: (venueUuid) => dispatch(loadRevenueCenters(venueUuid)),
    loadSuitesStaff: (currentVenueUuid) => dispatch(loadSuitesStaff(currentVenueUuid)),
    removeCustomerOrderingPreference: (preferenceUuid) => dispatch(removeCustomerOrderingPreference(preferenceUuid)),
    createAttendantSetting: (currentVenueUuid, params) => dispatch(createAttendantSetting(currentVenueUuid, params)),
    updateAttendantSetting: (params) => dispatch(updateAttendantSetting(params))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuiteEdit))
